import type { GutXAxisOrgan } from '@repo/types';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
import styles from './GutXAxisOrganList.module.css';
import OrganBadge from './OrganBadge';

type OrganRowProps = {
  organ: GutXAxisOrgan;
  /** `kit.age_at_sampling`, in days. */
  age: number;
  pregnant: boolean;
  sex: string;
  /** Omitted where the list only names the organs, as the PDF report would. */
  onSelect?: () => void;
};

export default function OrganRow({
  organ,
  age,
  pregnant,
  sex,
  onSelect,
}: OrganRowProps) {
  const content = (
    <>
      <OrganBadge organ={organ} age={age} pregnant={pregnant} sex={sex} />
      <Typography variant='body-s' className={styles.name}>
        {organ.display_name}
      </Typography>
      {onSelect && (
        <Icon name='chevronForward' size='m' className={styles.chevron} />
      )}
    </>
  );

  return (
    <li className={styles.row}>
      {onSelect ? (
        <button type='button' className={styles.content} onClick={onSelect}>
          {content}
        </button>
      ) : (
        <span className={styles.content}>{content}</span>
      )}
    </li>
  );
}
